import { Box, Button, TextField } from "@mui/material";
import { Tariff } from "../model/types";
import {
  dictionaryNamesTariffs,
  getImages,
  getRequestsWord,
  IImage,
  INamesTariffs,
} from "./utils";

import styles from "./TariffCard.module.scss";

interface Props {
  tariff: Tariff;
  promoValue: string;
  appliedPromoCode: string | null;
  discountedAmount: number | null;
  isPromoApplying: boolean;
  isPayDisabled?: boolean;
  onPromoChange: (value: string) => void;
  onApplyPromo: () => void;
  onResetPromo: () => void;
  onSelect: () => void;
}

export const TariffCard = ({
  tariff,
  promoValue,
  appliedPromoCode,
  discountedAmount,
  isPromoApplying,
  isPayDisabled = false,
  onPromoChange,
  onApplyPromo,
  onResetPromo,
  onSelect,
}: Props) => {
  const { name, count_request, amount } = tariff;

  const tariffMeta = dictionaryNamesTariffs[name as INamesTariffs];
  const image = getImages(name as IImage);

  const actualAmount = discountedAmount ?? amount;
  const pricePerRequest = Math.round(actualAmount / count_request);

  const isRecommended = tariffMeta?.isRecommended;

  const handlePromoAction = () => {
    if (appliedPromoCode) {
      onResetPromo();
      return;
    }

    onApplyPromo();
  };

  return (
    <Box
      className={`${styles.cardWrapper} ${isRecommended ? styles.cardRecommended : ""}`}
    >
      <div className={styles.card}>
        <div className={styles.title}>
          {image}
          <h5 className={styles.tariffName}>{tariffMeta?.title || "-"}</h5>
        </div>

        <p className={styles.attemptsInfo}>
          {getRequestsWord(count_request)} подбора кандидатов или ранжирования
          базы резюме под вакансию
        </p>

        <div className={styles.metaInfo}>
          <span>{tariffMeta?.period} дней</span>
          {/* <span>{tariffMeta?.usersText}</span> */}
        </div>

        <div className={styles.priceWrapper}>
          {discountedAmount !== null && (
            <span className={styles.oldCost}>{amount.toLocaleString()} ₽</span>
          )}

          <span className={styles.price}>
            {actualAmount.toLocaleString()} ₽
          </span>

          <span className={styles.pricePerRequest}>
            Цена за запрос {pricePerRequest.toLocaleString()} ₽
          </span>
        </div>

        <div className={styles.promoRow}>
          <TextField
            value={promoValue}
            onChange={(e) => onPromoChange(e.target.value)}
            placeholder="Промокод"
            size="small"
            disabled={isPromoApplying}
            className={styles.promoInput}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handlePromoAction();
              }
            }}
          />

          <Button
            variant="outlined"
            className={styles.promoBtn}
            onClick={handlePromoAction}
            disabled={
              isPromoApplying || (!promoValue.trim() && !appliedPromoCode)
            }
          >
            {appliedPromoCode ? "Отменить" : "Применить"}
          </Button>
        </div>

        <Button
          className={styles.buyBtn}
          onClick={onSelect}
          disabled={isPayDisabled}
        >
          Оплатить картой
        </Button>
      </div>

      <p className={styles.additionalInfo}>{tariffMeta?.text || "-"}</p>
    </Box>
  );
};
